exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-upload-tip[data-v-70f2820a] {\n  margin-top: 8px;\n  padding: 4px 10px;\n}\n.image-upload-tip[data-v-70f2820a]  .el-alert__icon {\n  font-size: 14px;\n  width: 14px;\n}\n.image-upload-tip[data-v-70f2820a]  .el-alert__title {\n  font-size: 12px;\n  line-height: 1.4;\n}\n", ""]);

// exports
